import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ApprovalProvider } from './context/ApprovalContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewApproval from './pages/NewApproval';
import ApprovalList from './pages/ApprovalList';
import LeaveMain from './pages/LeaveMain';
import LeaveNew from './pages/LeaveNew';
import LeaveHistory from './pages/LeaveHistory';
import LeaveDepartment from './pages/LeaveDepartment';
import ApprovalDetail from './pages/ApprovalDetail';
import Admin from './pages/Admin';
import './index.css';
function PrivateRoute({ children }) { const { user } = useAuth(); return user ? children : <Navigate to="/login" />; }
function AdminRoute({ children }) { const { user } = useAuth(); if (!user) return <Navigate to="/login" />; if (user.role !== 'admin') return <Navigate to="/" />; return children; }
function AppLayout({ children }) { return <><Navbar />{children}</>; }
function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><AppLayout><Dashboard /></AppLayout></PrivateRoute>} />
      <Route path="/new" element={<PrivateRoute><AppLayout><NewApproval /></AppLayout></PrivateRoute>} />
      <Route path="/list" element={<PrivateRoute><AppLayout><ApprovalList /></AppLayout></PrivateRoute>} />
      <Route path="/leave" element={<PrivateRoute><AppLayout><LeaveMain /></AppLayout></PrivateRoute>} />
      <Route path="/leave/department" element={<PrivateRoute><AppLayout><LeaveDepartment /></AppLayout></PrivateRoute>} />
      <Route path="/leave/history" element={<PrivateRoute><AppLayout><LeaveHistory /></AppLayout></PrivateRoute>} />
      <Route path="/leave/new" element={<PrivateRoute><AppLayout><LeaveNew /></AppLayout></PrivateRoute>} />
        <Route path="/detail/:id" element={<PrivateRoute><AppLayout><ApprovalDetail /></AppLayout></PrivateRoute>} />
      <Route path="/admin" element={<AdminRoute><AppLayout><Admin /></AppLayout></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
export default function App() {
  return <AuthProvider><ApprovalProvider><BrowserRouter><AppRoutes /></BrowserRouter></ApprovalProvider></AuthProvider>;
}